"use strict";

exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Context = _interopRequireDefault(require("./Context"));

var _jss = require("jss");

var _jssRtl = _interopRequireDefault(require("jss-rtl"));

var _styles = require("@material-ui/core/styles");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//for rtl support
// Configure JSS
var jss = (0, _jss.create)({
  plugins: [].concat((0, _styles.jssPreset)().plugins, [(0, _jssRtl.default)()])
});

var Provider = function Provider(_ref) {
  var children = _ref.children,
      _ref$persistKey = _ref.persistKey,
      persistKey = _ref$persistKey === void 0 ? 'theme' : _ref$persistKey,
      appConfig = _ref.appConfig;

  var _ref2 = appConfig || {},
      themeConfig = _ref2.theme;

  var _ref3 = themeConfig || {},
      defaultThemeID = _ref3.defaultThemeID,
      defaultIsDarkMode = _ref3.defaultIsDarkMode,
      defaultIsRTL = _ref3.defaultIsRTL;

  var _useState = (0, _react.useState)(defaultThemeID),
      themeID = _useState[0],
      setThemeID = _useState[1];

  var _useState2 = (0, _react.useState)(defaultIsDarkMode),
      isDarkMode = _useState2[0],
      setIsDarkMode = _useState2[1];

  var _useState3 = (0, _react.useState)(defaultIsRTL),
      isRTL = _useState3[0],
      setIsRTL = _useState3[1];

  var themeIDKey = persistKey + ":themeID";
  var isDarkModeKey = persistKey + ":isDarkMode";
  var isRTLKey = persistKey + ":isRTL";

  var toggleThisTheme = function toggleThisTheme(mode) {
    if (mode === 'isRTL') setIsRTL(!isRTL);
    if (mode === 'isDarkMode') setIsDarkMode(!isDarkMode);
  };

  (0, _react.useEffect)(function () {
    var persistThemeID = localStorage.getItem(themeIDKey);
    var persistIsDarkMode = localStorage.getItem(isDarkModeKey);
    var persistIsRTL = localStorage.getItem(isRTLKey);

    if (persistThemeID) {
      setThemeID(persistThemeID);
    }

    if (persistIsDarkMode) {
      // convert to boolean
      setIsDarkMode(persistIsDarkMode === 'true');
    }

    if (persistIsRTL) {
      //have to convert the stored string back to boolean
      setIsRTL(persistIsRTL === 'true' ? true : false);
    }
  }, [themeIDKey, isDarkModeKey, isRTLKey]);
  (0, _react.useEffect)(function () {
    try {
      localStorage.setItem(themeIDKey, themeID);
    } catch (error) {
      console.warn(error);
    }
  }, [themeID, themeIDKey]);
  (0, _react.useEffect)(function () {
    try {
      localStorage.setItem(isDarkModeKey, isDarkMode);
    } catch (error) {
      console.warn(error);
    }
  }, [isDarkMode, isDarkModeKey]);
  (0, _react.useEffect)(function () {
    try {
      localStorage.setItem(isRTLKey, isRTL);
    } catch (error) {
      console.warn(error);
    }
  }, [isRTL, isRTLKey]);
  return /*#__PURE__*/_react.default.createElement(_Context.default.Provider, {
    value: {
      themeID,
      setThemeID,
      isDarkMode,
      isRTL,
      toggleThisTheme
    }
  }, /*#__PURE__*/_react.default.createElement(_styles.StylesProvider, {
    jss: jss
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      direction: isRTL ? 'rtl' : 'ltr'
    }
  }, children)));
};

Provider.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.any
} : {};
var _default = Provider;
exports.default = _default;
module.exports = exports.default;